import _ from 'lodash';

export default function titleCase(text) {
  return _.startCase(_.lowerCase(text));
}
